<span class="mb-1">
  @if (lastUpdated) {
    <span>Results as of {{ lastUpdated | refreshTime }}</span>
  }
  <button
    class="download-button ms-1"
    (click)="onDownloadOrders()"
    matTooltip="Download orders"
    matTooltipPosition="right"
  >
    <fa-icon [icon]="downloadIcon" class="download-icon" />
  </button>
</span>
<div class="overflow-auto border rounded">
  <mat-table matSort [dataSource]="dataSource" [trackBy]="trackBy">
    <ng-container matColumnDef="detailsLink">
      <mat-header-cell *matHeaderCellDef>Details</mat-header-cell>
      <mat-cell *matCellDef="let order">
        <a [routerLink]="['', { outlets: { details: ['order', order.orderMasterId] } }]">
          Open details for {{ order.tmsOrderId }}
        </a>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="tripStatus">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Order status</mat-header-cell>
      <mat-cell *matCellDef="let order">
        <orders-trip-status-pill [arrivalStatus]="order.currentArrivalStatus" [tripStatus]="order.tripStatus" />
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="tmsOrderId">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Order #</mat-header-cell>
      <mat-cell *matCellDef="let order">
        <a [routerLink]="['', { outlets: { details: ['order', order.orderMasterId] } }]">
          {{ order.tmsOrderId }}
        </a>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="currentArrivalStatus">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Arrival status</mat-header-cell>
      <mat-cell *matCellDef="let order">
        @switch (order.currentArrivalStatus) {
          @case ('LATE') {
            <div class="text-danger">Late</div>
          }
          @case ('ATRISK') {
            <div class="text-warning">At risk</div>
          }
          @default {
            <div class="text-success">On time</div>
          }
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="isAssigned">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Planning status</mat-header-cell>
      <mat-cell *matCellDef="let order">
        @if (order.isAssigned) {
          Assigned
        } @else {
          <div class="d-flex align-items-center text-danger">
            <mat-icon>warning</mat-icon>
            Unassigned
          </div>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="bol">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Bol #</mat-header-cell>
      <mat-cell *matCellDef="let order">
        @if (order.shipmentDetails.bolNumber) {
          {{ order.shipmentDetails.bolNumber }}
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="customer">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Customer</mat-header-cell>
      <mat-cell *matCellDef="let order">
        <div>
          <div>{{ order.shipmentDetails.customerName }}</div>
          <div>{{ order.shipmentDetails.customerId }}</div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="tempRange">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Temp range</mat-header-cell>
      <mat-cell *matCellDef="let order">
        <orders-temp-range-column [order]="order" />
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="sensor1">
      <mat-header-cell mat-sort-header *matHeaderCellDef class="sensor-column">S1</mat-header-cell>
      <mat-cell
        *matCellDef="let order"
        class="sensor-column"
        [class]="{ 'temp-deviation-cell': order.trailer | sensorDeviation: 'sensor1' }"
      >
        @if (order.trailer | sensorDeviation: 'sensor1') {
          <mat-icon class="position-absolute deviation-icon text-danger">error</mat-icon>
        }
        {{ order.trailer.sensor1 | number: '1.0-0' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="sensor2">
      <mat-header-cell mat-sort-header *matHeaderCellDef class="sensor-column">S2</mat-header-cell>
      <mat-cell
        *matCellDef="let order"
        class="sensor-column"
        [class]="{ 'temp-deviation-cell': order.trailer | sensorDeviation: 'sensor2' }"
      >
        @if (order.trailer | sensorDeviation: 'sensor2') {
          <mat-icon class="position-absolute deviation-icon text-danger">error</mat-icon>
        }
        {{ order.trailer.sensor2 | number: '1.0-0' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="sensor3">
      <mat-header-cell mat-sort-header *matHeaderCellDef class="sensor-column">S3</mat-header-cell>
      <mat-cell
        *matCellDef="let order"
        class="sensor-column"
        [class]="{ 'temp-deviation-cell': order.trailer | sensorDeviation: 'sensor3' }"
      >
        @if (order.trailer | sensorDeviation: 'sensor3') {
          <mat-icon class="position-absolute deviation-icon text-danger">error</mat-icon>
        }
        {{ order.trailer.sensor3 | number: '1.0-0' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="returnAir1">
      <mat-header-cell mat-sort-header *matHeaderCellDef class="sensor-column">RA1</mat-header-cell>
      <mat-cell
        *matCellDef="let order"
        class="sensor-column"
        [class]="{ 'temp-deviation-cell': order.trailer | sensorDeviation: 'returnAir1' }"
      >
        @if (order.trailer | sensorDeviation: 'returnAir1') {
          <mat-icon class="position-absolute deviation-icon text-danger">error</mat-icon>
        }
        {{ order.trailer.returnAir1 | number: '1.0-0' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="returnAir2">
      <mat-header-cell mat-sort-header *matHeaderCellDef class="sensor-column">RA2</mat-header-cell>
      <mat-cell
        *matCellDef="let order"
        class="sensor-column"
        [class]="{ 'temp-deviation-cell': order.trailer | sensorDeviation: 'returnAir2' }"
      >
        @if (order.trailer | sensorDeviation: 'returnAir2') {
          <mat-icon class="position-absolute deviation-icon text-danger">error</mat-icon>
        }
        {{ order.trailer.returnAir2 | number: '1.0-0' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="returnAir3">
      <mat-header-cell mat-sort-header *matHeaderCellDef class="sensor-column">RA3</mat-header-cell>
      <mat-cell
        *matCellDef="let order"
        class="sensor-column"
        [class]="{ 'temp-deviation-cell': order.trailer | sensorDeviation: 'returnAir3' }"
      >
        @if (order.trailer | sensorDeviation: 'returnAir3') {
          <mat-icon class="position-absolute deviation-icon text-danger">error</mat-icon>
        }
        {{ order.trailer.returnAir3 | number: '1.0-0' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="lastUpdatedDate">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Last updated temp date</mat-header-cell>
      <mat-cell *matCellDef="let order">{{ order.trailer.lastUpdatedDate | date: 'EEE M/d - h:mm a' }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="origin">
      <mat-header-cell mat-sort-header *matHeaderCellDef class="large-column">Origin</mat-header-cell>
      <mat-cell *matCellDef="let order" class="large-column">
        <div>
          <div>{{ order.origin.name }}</div>
          <div>{{ order.origin.cityState }}</div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="originEta">
      <mat-header-cell mat-sort-header *matHeaderCellDef>ETA to origin</mat-header-cell>
      <mat-cell *matCellDef="let order">
        @if (order.tripStatus === 'Scheduled') {
          {{ order.origin.scheduledETA | date: 'M/dd h:mm a' }}
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="completedStops">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Completed stops</mat-header-cell>
      <mat-cell *matCellDef="let order">
        {{ order.completedStops }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="remainingStops">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Stops remaining</mat-header-cell>
      <mat-cell *matCellDef="let order">
        {{ order.remainingStops }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="remainingMilesToNextStop">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Distance to next stop</mat-header-cell>
      <mat-cell *matCellDef="let order">{{ order.remainingMilesToNextStop }} mi</mat-cell>
    </ng-container>

    <ng-container matColumnDef="nextStop">
      <mat-header-cell mat-sort-header *matHeaderCellDef class="large-column">Next stop</mat-header-cell>
      <mat-cell *matCellDef="let order" class="large-column">
        <div>
          <div>{{ order.nextStop.name }}</div>
          <div>{{ order.nextStop.cityState }}</div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="nextStopEta">
      <mat-header-cell mat-sort-header *matHeaderCellDef class="large-column">ETA to next stop</mat-header-cell>
      <mat-cell *matCellDef="let order" class="large-column">
        @if (order.tripStatus === 'InTransit') {
          {{ order.nextStop.scheduledETA | date: 'M/dd h:mm a' }}
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="destination">
      <mat-header-cell mat-sort-header *matHeaderCellDef class="large-column">Destination</mat-header-cell>
      <mat-cell *matCellDef="let order" class="large-column">
        <div>
          <div>{{ order.destination.name }}</div>
          <div>{{ order.destination.cityState }}</div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="destinationEta">
      <mat-header-cell mat-sort-header *matHeaderCellDef class="large-column">ETA to destination</mat-header-cell>
      <mat-cell *matCellDef="let order" class="large-column">
        @if (order.tripStatus === 'InTransit') {
          {{ order.destination.scheduledETA | date: 'M/dd h:mm a' }}
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="pickupTime">
      <mat-header-cell mat-sort-header *matHeaderCellDef class="large-column">
        Scheduled pick-up date/time
      </mat-header-cell>
      <mat-cell *matCellDef="let order" class="large-column">
        {{ order.origin.scheduledArrivalTime | date: 'EEE M/d - h:mm a' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="deliveryTime">
      <mat-header-cell mat-sort-header *matHeaderCellDef class="large-column">
        Scheduled delivery date/time
      </mat-header-cell>
      <mat-cell *matCellDef="let order" class="large-column">
        {{ order.destination.scheduledArrivalTime | date: 'EEE M/d - h:mm a' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="tractor">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Tractor #</mat-header-cell>
      <mat-cell *matCellDef="let order">
        {{ order.tractor.tractorNumber }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="trailer">
      <mat-header-cell mat-sort-header *matHeaderCellDef>Trailer #</mat-header-cell>
      <mat-cell *matCellDef="let order">
        {{ order.trailer.trailerId }}
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columns; sticky: true" />
    <mat-row
      *matRowDef="let row; columns: columns"
      class="clickable"
      (click)="onClick(row)"
      [attr.data-temp-deviation]="row.hasTempDeviation"
      [attr.data-arrival-status]="row.currentArrivalStatus"
    />
  </mat-table>
</div>
<mat-paginator [length]="length" [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons class="bg-transparent" />
